import type { SiteProfileDto } from '../models/site-api.model';

export function resolveSiteLogoUrl(profile: SiteProfileDto | null): string {
  const url = profile?.logoUrl?.trim();
  if (url) {
    return url;
  }
  return '';
}

export function hasTextLogo(profile: SiteProfileDto | null): boolean {
  return !profile?.logoUrl?.trim();
}
